package com.vidaensupalabra.vsp.ui.theme

import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.rgba

// Colores existentes adaptados a CSS
val Purple80 = Color("#D0BCFF")
val PurpleGrey80 = Color("#CCC2DC")
val Pink80 = Color("#EFB8C8")

val Purple40 = Color("#6650a4")
val PurpleGrey40 = Color("#625b71")
val Pink40 = Color("#7D5260")

// Nuevos colores añadidos
val VspBase = Color("#263246") // VSP base color
val VspMarco = Color("#28B4B4") // VSP marco color
val VspMarcoTransparente = rgba(40, 180, 180, 0.06) // 0x10 aprox 6% de opacidad
val VspMarcoTransparente50 = rgba(40, 180, 180, 0.31) // 0x50 aprox 31% de opacidad
val VspBaseTransparente = rgba(38, 50, 70, 0.44) // 0x70 aprox 44% de opacidad

// Colores comunes existentes
val White = Color("#FFFFFF")
val Black = Color("#000000")
val Yellow = Color("#FFEB3B")
val Blue = Color("#2196F3")

// Más colores comunes añadidos
val Red = Color("#F44336")
val Green = Color("#4CAF50")
val Orange = Color("#FF9800")
val Teal = Color("#009688")
val Indigo = Color("#3F51B5")
val Pink = Color("#E91E63")
val Purple = Color("#9C27B0")
val DeepPurple = Color("#673AB7")
val LightBlue = Color("#03A9F4")
val Cyan = Color("#00BCD4")
val Lime = Color("#CDDC39")
val LightGreen = Color("#8BC34A")
val Amber = Color("#FFC107")
val DeepOrange = Color("#FF5722")
val Brown = Color("#795548")
val Grey = Color("#9E9E9E")
val BlueGrey = Color("#607D8B")
val Facebookcolor = Color("#007aff")